import type { MotionSkin } from "./types";

export const rainySkin: MotionSkin = {
  id: "rainy",
  label: "梅雨",
  season: "tsuyu",
  palette: {
    backgroundTop: "#d9e9f2",
    backgroundBottom: "#eef7f6",
    foreground: "#182235",
    muted: "#5f6f82",
    up: "#19a974",
    down: "#5b72d6",
    grid: "rgba(70,92,120,.18)",
    card: "rgba(247,252,255,.78)",
    panel: "rgba(255,255,255,.80)",
    accent: "#7f6bd6"
  },
  typography: { family: "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif", titleWeight: 800 },
  decoration: "rainy",
  upEffect: "rainbow",
  downEffect: "heavy-rain",
  assetSlots: {
    background: "/skins/rainy/background.png",
    tipIdle: "/skins/rainy/tipIdle.png",
    tipUp: "/skins/rainy/tipUp.png",
    tipDown: "/skins/rainy/tipDown.png"
  }
};
